declare global {
  interface Window {
    Pylon?: (...args: unknown[]) => void
    pylon?: { chat_settings?: Record<string, unknown> }
  }
}

/**
 * Initializes the Pylon command queue so calls made before the script loads
 * are buffered and replayed once the widget is ready.
 */
function initQueue(): void {
  if (typeof window.Pylon === 'function') return

  window.Pylon = function (...args: unknown[]) {
    const queue = ((window.Pylon as unknown as { _q?: unknown[] })?._q) || []
    queue.push(args)
    ;(window.Pylon as unknown as { _q: unknown[] })._q = queue
  }
}

/**
 * Reads the CSP nonce from a `<meta property="csp-nonce">` tag, if present.
 */
function getCspNonce(): string | undefined {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="csp-nonce"]')
  return meta?.content || undefined
}

/**
 * Dynamically loads the Pylon widget script.
 * Resolves when the script has loaded; rejects on error.
 */
export function loadPylonWidget(appId: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (document.querySelector('script[data-pylon-widget]')) {
      resolve()
      return
    }

    initQueue()

    const script = document.createElement('script')
    script.src = `https://widget.usepylon.com/widget/${appId}`
    script.async = true
    script.setAttribute('data-pylon-widget', 'true')

    const nonce = getCspNonce()
    if (nonce) {
      script.nonce = nonce
    }

    script.onload = () => {
      window.dispatchEvent(new Event('pylonLoaded'))
      resolve()
    }
    script.onerror = () => reject(new Error('Failed to load Pylon widget script'))

    document.head.appendChild(script)
  })
}
